/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CmsButtonApiProps, CmsButtonApiPropsSchema } from './cms-button'
import {
  type ProductCategories,
  ProductCategoriesSchema,
} from './product-category'

/* TypeScript */
export type AnimatedProductCheckpointsApiProps = {
  technicalName?: string
  title?: string
  subtitle?: string
  categories: ProductCategories
  button?: CmsButtonApiProps
}

/* Schemas */
export const AnimatedProductCheckpointsApiPropsSchema = z.object({
  technicalName: z.string().optional(),
  title: z.string().optional(),
  subtitle: z.string().optional(),
  categories: ProductCategoriesSchema,
  button: CmsButtonApiPropsSchema.optional(),
})

/* Schemas validation */
type TestAnimatedProductCheckpointsProps = ExpectTrue<
  Equal<
    AnimatedProductCheckpointsApiProps,
    z.infer<typeof AnimatedProductCheckpointsApiPropsSchema>
  >
>
